import React, { useState } from 'react';
import axios from 'axios';
import logo from '../../Assets/img/Neoin-logo.png'; // Update with your logo path
import { useQuantityContext } from '../QuantityContext';
import { useLocation } from 'react-router-dom';
// import { Height } from '@material-ui/icons';


function RecommendationSubmission() {

    const apiKey = process.env.REACT_APP_API_KEY


    const { handleSuccess, handleFailure } = useQuantityContext();
    const [recommendation, setRecommendation] = useState('');
    const [closeTab, setCloseTab] = useState(false);
    const location = useLocation(); // Access the location object

    // Extract token and contactId from query parameters
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const contactId = queryParams.get("contactId");

    // console.log("token", token);

    // console.log("contactid", contactId)


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Build API payload
        const payload = {
            contactId,
            recommendationText: recommendation,
        };

        const headers = {
            'x-api-key': apiKey,
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };

        // console.log("headers", headers);


        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/submit-recommendation`, // Update with actual endpoint
                payload,
                { headers: headers } // Corrected headers syntax
            );


            if (response.data.status === 'SUCCESS') {
                setRecommendation('');
                setCloseTab(true); handleSuccess('Recommendation submitted successfully!');
            }

        } catch (error) {
            handleFailure('Failed to submit the recommendation. ', `${error.message}`);
        }
    };

    return (
        <>
            {!closeTab ?
                <div style={styles.topcontainer}>

                    <div style={styles.container}>
                        <div style={styles.header}>
                            <img src={logo} alt="NEOIN logo" style={styles.logo} />
                            <h2>Submit a Recommendation</h2>
                        </div>
                        <p>
                            Please write your recommendation for the user below. This recommendation will be submitted for review and saved in our records.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <textarea
                                value={recommendation}
                                onChange={(e) => setRecommendation(e.target.value)}
                                placeholder="Write your recommendation here..."
                                style={styles.textarea}
                                required
                            />
                            <div style={styles.buttons}>
                                <button type="submit" style={styles.submitButton}>
                                    SUBMIT
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                :
                <div style={styles.topcontainer}>
                    <div style={styles.container}>
                        <div style={styles.header}>
                            <img src={logo} alt="NEOIN logo" style={styles.logo} />
                            <h2>Request Already Processed!</h2>
                        </div>
                        <p>
                            This Request has already been processed. Please check the Request ID.
                        </p>
                    </div>
                </div>
            }
        </>


    );
}

const styles = {
    topcontainer: {
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        display: 'flex'


    },
    container: {
        maxWidth: '600px',
        margin: 'auto',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
    },
    header: {
        marginBottom: '20px',
    },
    logo: {
        width: '100px',
        marginBottom: '10px',
    },
    textarea: {
        width: '100%',
        height: '150px',
        marginBottom: '20px',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '16px',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
    },
    submitButton: {
        border: 'none',
        color: '#fff',
        padding: '10px 20px',
        borderRadius: '4px',
        cursor: 'pointer',
        background: 'var(--Primary-Color, #0044C6)',
    },
};

export default RecommendationSubmission;
